import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./BlogSection.css";
import CategoryName from "./BlogCategoryName";
import BlogCard from "./BlogCard";

interface Author {
  id: number;
  name: string;
}
interface BlogPost {
  id: number;
  title: string;
  text: string;
  image: string;
  author: Author;
  created_at: string;
  slug?: string;
}
interface Category {
  id: number;
  name: string;
  blog_count: number;
  blog: BlogPost[];
}

const BlogSection: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("https://api.tellida.com/api/categories")
      .then(res => setCategories(res.data))
      .catch(() => console.log("Failed to load categories"))
      .finally(() => setLoading(false));
  }, []);

  const handleReadClick = (slug: string | undefined, id: number) => {
    navigate(slug ? `/blog/${slug}` : `/blog/${id}`);
  };

  return (
    <>
      <Helmet>
        <title>Tellida Blog – Insights, Tips & Updates</title>
        <meta
          name="description"
          content="Discover articles, guides, and insights from Tellida on technology, outsourcing, business, and lifestyle."
        />
        <link rel="canonical" href="https://tellida.com/blog" />
      </Helmet>

      <section className="global-blog-container">
        {loading && <div className="loading-text">Loading...</div>}

        {categories.map(category =>
          category.blog_count > 0 && (
            <div key={category.id} className="category-block">
              <CategoryName name={category.name} />

              <div className="blog-section">
                {category.blog
                  .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                  .map(post => (
                    <BlogCard
                      key={post.id}
                      title={post.title}
                      excerpt={post.text.slice(0, 150) + (post.text.length > 150 ? "..." : "")}
                      author={post.author.name}
                      date={new Date(post.created_at).toLocaleDateString()}
                      imageUrl={post.image}
                      category={category.name}
                      onReadClick={() => handleReadClick(post.slug, post.id)}
                    />
                  ))}
              </div>
            </div>
          )
        )}
      </section>
    </>
  );
};

export default BlogSection;
